export default class CellIntoViewScroller {
    public static scrollCellIntoView(cell: Element, dropdownIsBeingOpened: boolean): void {
        const cellArea: DOMRect = cell.getBoundingClientRect();
        const scrollToTheLeft: number = CellIntoViewScroller.leftMostVisiblePixel() - cellArea.left;
        const scrollToTheRight: number = cellArea.right - CellIntoViewScroller.rightMostVisiblePixel();
        const scrollUp: number = CellIntoViewScroller.topMostVisiblePixel() - cellArea.top;
        let scrollDown: number = cellArea.bottom - CellIntoViewScroller.bottomMostVisiblePixel();

        if (dropdownIsBeingOpened) {
            scrollDown += 200;
        } else {
            scrollDown += 18;
        }

        const scrollElement: Element = document.querySelector('#planbord-holder')!;

        if (scrollToTheLeft > 0) {
            scrollElement.scrollLeft -= scrollToTheLeft;
        } else if (scrollToTheRight > 0) {
            scrollElement.scrollLeft += scrollToTheRight + 17;
        }

        if (scrollUp > 0) {
            scrollElement.scrollTop -= scrollUp;
        } else if (scrollDown > 0) {
            scrollElement.scrollTop += scrollDown;
        }
    }

    private static leftMostVisiblePixel(): number {
        const leftCells: NodeListOf<Element> = document.querySelectorAll('#planbord-holder .planbord-grid-row:first-child .planbord-left-index');
        let leftMostVisiblePixel: number = 0;
        for (const leftCell of leftCells) {
            const rect: DOMRect = leftCell.getBoundingClientRect();
            if (rect.right > leftMostVisiblePixel) {
                leftMostVisiblePixel = rect.right;
            }
        }

        return leftMostVisiblePixel;
    }

    private static rightMostVisiblePixel(): number {
        const hourBalanceCells: NodeListOf<Element> = document.querySelectorAll('#planbord-holder thead tr:first-child td.hour-balance');
        let rightMostVisiblePixel: number = window.innerWidth;
        for (const hourBalanceCell of hourBalanceCells) {
            const rect: DOMRect = hourBalanceCell.getBoundingClientRect();
            if (rect.left > 0 && rect.left < rightMostVisiblePixel) {
                rightMostVisiblePixel = rect.left;
            }
        }

        return rightMostVisiblePixel;
    }

    private static topMostVisiblePixel(): number {
        return document.querySelector('.divider')!.getBoundingClientRect().bottom;
    }

    private static bottomMostVisiblePixel(): number {
        return window.innerHeight;
    }
}
